"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MarketplaceConfigClientImpl = /** @class */ (function () {
    function MarketplaceConfigClientImpl(configSet) {
        this.configSet = configSet;
    }
    MarketplaceConfigClientImpl.prototype.getMarketplace = function (context, weblabContext) {
        return this.configSet.getObject("marketplace", context === null || context === void 0 ? void 0 : context.toRawContext(), weblabContext);
    };
    return MarketplaceConfigClientImpl;
}());
exports.default = MarketplaceConfigClientImpl;
